module.exports = __webpack_public_path__ + "img/2.83d0c785.jpg";